import React, { useContext } from 'react'
import { VideoContext } from '~/service/videoConn'
import JanusWebsocketConn from './janus/service/JanusWebsocketConn'
import Janus from './janus/containers/Janus'
import Draggable from 'react-draggable'
import { useVideoStore } from '../components/janus/VideoSetting'
import classNames from 'classnames'

const Main: React.FC = ({}) => {
  const { videoRoom } = useContext(VideoContext)
  const { small } = useVideoStore()
  const server = 'https://' + process.env.JANUS_DOMAIN + '/janus'

  return (
    <>
      {videoRoom.active && (
        <Draggable
          disabled={!small}
          position={!small ? { x: 0, y: 0 } : undefined}
          bounds="parent"
        >
          <div className={classNames('video', { 'video--small': small })}>
            <JanusWebsocketConn token={videoRoom.agentToken} type="agent">
              <Janus
                server={server}
                videoId={videoRoom.agentId}
                room={videoRoom.room}
                pin={videoRoom.pin}
                token={videoRoom.agentToken}
              />
            </JanusWebsocketConn>
          </div>
        </Draggable>
      )}
    </>
  )
}

export default Main
